import { FeatureFlagName } from './feature-flags'

// WARNING! Don't put anything here that you do not want to be exposed to the client.
export const CONFIG = [
  'NEXT_PUBLIC_ASSET_HOST',
  'NEXT_PUBLIC_CONTENT_SERVICE',
  'NEXT_PUBLIC_CONTENT_SERVICE_V2',
  'NEXT_PUBLIC_ALGOLIA_APPLICATION_ID',
  'NEXT_PUBLIC_ALGOLIA_SEARCH_KEY',
  'NEXT_PUBLIC_MKP_ALGOLIA_APPLICATION_ID',
  'NEXT_PUBLIC_MKP_ALGOLIA_SEARCH_KEY',
  'NEXT_PUBLIC_ALGOLIA_CUSTOM_ORIGIN',
  'NEXT_PUBLIC_MAPS_API',
  'NEXT_PUBLIC_SCENTREGROUP_API',
  'NEXT_PUBLIC_SCENTREGROUP_API_KEY',
  'NEXT_PUBLIC_SENTRY_DSN',
  'NEXT_PUBLIC_SENTRY_ENV',
  ...Object.keys(FeatureFlagName),
]

export const CONFIG_PROCESS_ENV_MAP = CONFIG.reduce((acc, key) => {
  acc[key] = process.env[key] // eslint-disable-line no-process-env

  return acc
}, {})
